import { useTranslation } from 'react-i18next';

import { ConnectedAppsTable } from '@/features/connected-apps';

import { AdminPageShell } from '../AdminPageShell';

export const ConnectedAppsPage = () => {
  const { t } = useTranslation('admin');

  return (
    <AdminPageShell title={t('connectedApps.connectedAppsPage.connectedApps')}>
      <ConnectedAppsTable />
    </AdminPageShell>
  );
};
